import React from 'react'
import {Form, Button, Message, Modal, Image, Confirm, Dropdown} from 'semantic-ui-react'
import {createAPIClient} from '../../../../../services/api'
import {connect} from 'react-redux'
import {getTemplatesAction} from '../../../../../actions/template.action'

const {Field} = Form
const modalStyle = { marginTop: '5%', marginLeft: 'auto', marginRight: 'auto'}
const confirmStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
}

class EditForm extends React.Component {
  constructor (props) {
    super(props)
    var member = props.member
    var templates = []
    for (var i = 0; i < member.templates.length; i++) {
      templates.push(member.templates[i]._id)
    }
    member.templates = templates
    this.state = {
      openConfirm: false,
      member: props.member,
      postSuccess: false,
      error: undefined,
      isLoading: false,
      searchQuery: null
    }
  }
  showConfirm () {
    this.setState({openConfirm: true})
  }
  handleCancel () {
    this.setState({openConfirm: false})
  }
  handleConfirm () {
    const api = createAPIClient()
    api.delete(`/api/users/teammembers/${this.state.member._id}`)
      .then(response => {
        this.setState({openConfirm: false})
        this.props.finishEditing(true)
      })
      .catch(error => {
        console.log(error)
      })
  }
  cancelEdit () {
    this.props.finishEditing(false)
  }
  onFieldChange (e) {
    const member = this.state.member
    member[e.target.name] = e.target.value
    this.setState({member: member})
  }
  onDropDownChange (e, {value}) {
    this.onFieldChange({target: {name: 'role', value: value}})
  }
  onEditFormSubmit () {
    // call the api
    this.setState({isLoading: true})
    const api = createAPIClient()
    const form = {
      first_name: this.state.member.first_name,
      last_name: this.state.member.last_name,
      email: this.state.member.email,
      role: this.state.member.role,
      templates: this.state.member.templates
    }
    api.put(`/api/users/teammembers/${this.state.member._id}`, form)
      .then(response => {
        this.props.finishEditing(true)
        this.props.getTemplatesAction(results => {
        })
      })
      .catch(error => {
        console.log(error)
      })
  }
  handleChange (e, { value }) {
    const member = this.state.member
    member['templates'] = value
    this.setState({member: member})
  }
  handleSearchChange (e, { searchQuery }) {
    this.setState({ searchQuery })
  }
  render () {
    const options = this.props.templates.templates.map(template => {
      return {
        'key': template._id,
        'text': template.name,
        'value': template._id
      }
    })
    const memberOptions = [{key: 1, value: 'Observer', text: 'Observer'}, {key: 2, value: 'Admin', text: 'Admin'}]
    const editForm = (
      <div>
        <h2> Edit team member</h2>
        <Form id='editForm' loading={this.state.isLoading} onSubmit={this.onEditFormSubmit.bind(this)}>
          {this.state.postSuccess ? (<Message positive>
            <Message.Header>Successfully update team member</Message.Header>
          </Message>) : undefined}

          {this.state.error ? (<Message negative>
            <Message.Header>{this.props.editForm.errorMessage}</Message.Header>
          </Message>) : undefined}

          <Field>
            <label htmlFor='first_name'>First Name</label>
            <input autoFocus type='text' id='first_name' name='first_name' value={this.state.member.first_name}
              onChange={this.onFieldChange.bind(this)} required />
          </Field>
          <Field>
            <label htmlFor='last_name'>Last Name</label>
            <input autoFocus type='text' id='last_name' name='last_name' value={this.state.member.last_name}
                   onChange={this.onFieldChange.bind(this)} required />
          </Field>
          {this.state.member.role !== 'Owner' ? (
            <Field>
              <label htmlFor='email'>Email</label>
              <input autoFocus type='email' id='email' name='email' value={this.state.member.email}
                     onChange={this.onFieldChange.bind(this)} required />
            </Field>
          ) : undefined}
          {this.state.member.role !== 'Owner' ? (
            <Field>
              <label>Role</label>
              <Dropdown
                placeholder='Select team member'
                fluid selection options={memberOptions}
                onChange={this.onDropDownChange.bind(this)}
                defaultValue={this.state.member.role}
              />
            </Field>
          ) : undefined}
          <Field>
            <label>Receive email notifications for</label>
            <Dropdown
              fluid
              selection
              multiple
              search
              options={options}
              value={this.state.member.templates}
              placeholder='Select templates'
              onChange={this.handleChange.bind(this)}
              onSearchChange={this.handleSearchChange.bind(this)}
            />
          </Field>
        </Form>
      </div>
    )
    const modal = (
      <Modal open={this.props.showEditForm} style={modalStyle} onClose={this.cancelEdit.bind(this)}>
        <Modal.Header style={{overflow: 'hidden'}}>
          Edit Team Member
          <a href='#'>
            <Image onClick={this.cancelEdit.bind(this)} style={{float: 'right', fontSize: '12px', verticalAlign: 'middle', lineHeight: '12px'}} avatar src={'/icons/close_432859.svg'} />
          </a>
          <a href='#'>
            <Image onClick={this.showConfirm.bind(this)} style={{float: 'right', fontSize: '12px', verticalAlign: 'middle', lineHeight: '12px', marginRight: '20px'}} avatar src={'/icons/delete_1397562.svg'} />
          </a>
          <Confirm
            style={confirmStyle}
            open={this.state.openConfirm}
            onCancel={this.handleCancel.bind(this)}
            onConfirm={this.handleConfirm.bind(this)}
            content='Are you sure you want to delete this team member?'
            confirmButton='Yes'
          />
        </Modal.Header>
        <Modal.Content>
          <Modal.Description>
            {editForm}
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button primary icon='check' content='Update' type='submit' form='editForm' />
        </Modal.Actions>
      </Modal>
    )
    return modal
  }
}

function mapStateToProps (state) {
  return {templates: state.templates}
}

export default connect(mapStateToProps, {getTemplatesAction})(EditForm)




// WEBPACK FOOTER //
// ./src/pages/settings/team/components/edit/index.js